import { MapperBase } from '../../../utilities/mapper-base';
import { DocViewerContextDoc } from '@models/ui/doc-viewer-context-doc.model';
import { EmailThreadDoc } from 'src/app/components/doc-viewer-new/doc-viewer-context-panel-template/email-threading-context-panel/email-thread-doc.model';

export class EmailThreadDocToDocViewerContextDocMapper extends MapperBase<EmailThreadDoc, DocViewerContextDoc> {
    map(source: EmailThreadDoc): DocViewerContextDoc {
        const dest = new DocViewerContextDoc();
        dest.docId = source.docId;
        dest.docTitle = source.docTitle;
        dest.hasChildren = false;
        dest.displayType= 'email';
        return dest;
    }

}
